module.exports = __webpack_public_path__ + "img/bag.60023a9f.svg";